import Close from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { type SxProps, type Theme } from '@mui/material/styles';

const DEFAULT_CLOSE_ARIA_LABEL = 'close';

export const DialogCloseButton = ({
  ariaLabel,
  onClick,
  sx,
}: {
  ariaLabel?: string;
  onClick: () => void;
  sx?: SxProps<Theme>;
}) => {
  const baseSx: SxProps<Theme> = (theme) => ({
    color: theme.palette.grey[500],
    position: 'absolute',
    right: 8,
    top: 8,
  });

  return (
    <IconButton
      aria-label={ariaLabel ?? DEFAULT_CLOSE_ARIA_LABEL}
      onClick={onClick}
      sx={[baseSx, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
    >
      <Close />
    </IconButton>
  );
};
